import React__default, { useState } from 'react';
import cn from 'classnames/bind';
import useTimeout from './useTimeout.js';
import classes from './fader.scss.js';

const transitionDurationMs = 300;
const cx = cn.bind(classes);
const Fader = React__default.forwardRef(({ removeAfter, children, onRemoved }, ref) => {
    const [removing, setRemoving] = useState(false);
    const [clearTimeoutRemoving] = useTimeout(() => {
        setRemoving(true);
    }, removeAfter);
    const [, setTimeoutRemoved] = useTimeout(onRemoved, removeAfter === 0 ? 0 : removeAfter + transitionDurationMs);
    /**
     * @description
     * Export to the parents removing method, needed to
     * implement Notification "close" button
     */
    React__default.useImperativeHandle(ref, () => ({
        remove: () => {
            clearTimeoutRemoving();
            setRemoving(true);
            //Reset interval removed:
            setTimeoutRemoved(transitionDurationMs);
        },
    }));
    return (React__default.createElement("div", { className: cx('fader', removing ? 'hide' : 'show') }, children));
});
Fader.displayName = 'Fader';

export { Fader };
//# sourceMappingURL=Fader.js.map
